import { withRouter } from 'react-router-dom';
import Auth from './Auth';

export default withRouter(Auth);
